// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__YyK2U","red":"style_red__agKAq","infoCard":"style_infoCard__daML8"};